import React from 'react';
import { Link } from 'react-router-dom';

export default function AppFooter() {
  return (
    <footer className="border-t border-[#27272A] mt-12 py-5">
      <div className="max-w-[1400px] mx-auto px-6 flex items-center justify-between">
        <span className="text-xs text-[#71717A]">HighConnect</span>
        <div className="flex items-center gap-4">
          <Link to="/privacy-policy" className="text-xs text-[#71717A] hover:text-[#EDEDF0] transition-colors" data-testid="footer-privacy-link">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="text-xs text-[#71717A] hover:text-[#EDEDF0] transition-colors" data-testid="footer-terms-link">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
}
